module.exports = __webpack_public_path__ + "static/shortsword-0f073b1f2172729e818cfed0663857a3.jpg";